import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Tabs } from 'antd';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box } from 'atoms';
import {
	VendorDetailsForm,
	BankingDetailsForm,
	DocumentInfoForm,
	TaxDeductionForm,
	OtherDetailsForm,
} from 'components/forms/vendor';
import { getClientList } from 'store/clientSlice';

export default function CreateVendorForm() {
	const [formData, setFormData] = useState({});
	const [activeTab, setActiveTab] = useState(1);
	const [searchParams, setSearchParams] = useSearchParams();
	const dispatch = useDispatch();
	const { id } = useParams();

	const onChange = useCallback(
		(key) => {
			/**
			 * On Edit mode only allow to go other other tabs
			 */
			if (id) {
				const newQueryParameters = new URLSearchParams();
				console.log('newQueryParameters', newQueryParameters);
				setSearchParams({
					...newQueryParameters,
					tab: key,
					isEdit: searchParams.get('isEdit') || false,
				});
				setActiveTab(key);
			}
		},
		[id, setSearchParams, searchParams]
	);

	useEffect(() => {
		const tab = Number(searchParams.get('tab'));
		console.log('Client Form tab', tab);

		if (tab) {
			onChange(tab);
		}
	}, [onChange, searchParams]);

	useEffect(() => {
		console.log('Client Form activeTab', activeTab);
	}, [activeTab]);

	useEffect(() => {
		if (id) {
			console.log('id 2', id);

			dispatch(
				getClientList({
					search_type: 'vendor',
					filter_by: {
						id,
					},
				})
			).then((res) => {
				console.log('res', res?.data?.[0]);
				setFormData(res?.data?.[0]);
			});
		}
	}, [dispatch, id]);

	console.log('formData', formData);

	const tabs = useMemo(
		() => [
			{
				id: 1,
				label: 'Vendor Details',
				form: (
					<VendorDetailsForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.vendor_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 2,
				label: 'Bank Details',
				form: (
					<BankingDetailsForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.banking_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 3,
				label: 'Document Details',
				form: (
					<DocumentInfoForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.document_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 4,
				label: 'Tax Deduction',
				form: (
					<TaxDeductionForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.tax_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 5,
				label: 'Other Details',
				form: (
					<OtherDetailsForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.other_info}
						activeTab={activeTab}
					/>
				),
			},
		],
		[activeTab, formData]
	);

	return (
		<Box>
			<Tabs
				onChange={onChange}
				tabPosition="left"
				type="line"
				activeKey={activeTab}
				defaultActiveKey={1}
				items={tabs.map((tab) => ({
					label: `${tab.id}. ${tab.label}`,
					key: tab.id,
					children: tab.form,
				}))}
			/>
		</Box>
	);
}
